import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import ClassWatcher from './classWatcher';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class Animations {
    
    static init() {

		var bodyHeight = document.querySelector('body').offsetHeight;
		
		var header = document.querySelector('.header');

		/* *********** */
		/* STICKY MENU */
		/* *********** */

		let stickyMenuST = ScrollTrigger.create({
			trigger: ".header",
			start: "2px",
			end: "+=" + bodyHeight,
			markers: false,
			pin: ".header",
			pinSpacing: false,
			onEnter: () => header.classList.add('header--negative'),
			onLeave: () => header.classList.remove('header--negative'),
			onEnterBack: () => header.classList.add('header--negative'),
			onLeaveBack: () => header.classList.remove('header--negative'),
		});

		/* ********* */
		/* SCROLL TO */
		/* ********* */
		
		const scrollToLinks = document.querySelectorAll('.scroll-to-link');
		const scrollToLinksArray = Array.from(scrollToLinks);

		scrollToLinksArray.forEach(link => {

			const href = link.getAttribute("href");

			link.addEventListener('click', event => {
				event.preventDefault();
				gsap.to(window, {duration: .75, scrollTo:{y: href, offsetY: 200 }});
			});
		})

		/* ****************** */
		/* GENERAL ANIMATIONS */
		/* ****************** */

		const animateBottom = document.querySelectorAll('.animate-bottom');

		animateBottom.forEach(item => {

			let tl = gsap.timeline({ paused: true });

			tl.from(item, {
				duration: 1,
				opacity: 0,
				y: 50,
				ease: "expo.out"
			});

			ScrollTrigger.create({
				trigger: item,
				start: "top 85%",
				end: "bottom 90%",
				animation: tl,
				markers: false,
				toggleActions: "play none none reverse"
			});

		});
			

		/* ************************** */
		/* HEADER AND HERO ANIMATIONS */
		/* ************************** */

		let tlHeaderHero = gsap.timeline({ paused: false });

		tlHeaderHero.to(header, {
			duration: .75,
			opacity: 1,
			ease: "Power1.out",
			delay: 1,
			force3D: true
		});

		/* ***************************** */
		/* OUR VALUES STAGGER ANIMATIONS */
		/* ***************************** */

		const animateStaggerValue = document.querySelectorAll('.animate-stagger-value');

		let tlStaggerValues = gsap.timeline({ paused: true });

		tlStaggerValues.from(animateStaggerValue, {
			duration: .75,
			opacity: 0,
			y: 50,
			ease: "expo.out",
			stagger: 0.125,
			delay: 0.25
		});

		ScrollTrigger.create({
			trigger: '.animate-stagger-values-container',
			start: "top 85%",
			end: "bottom 90%",
			animation: tlStaggerValues,
			markers: false,
			toggleActions: "play none none reverse"
		});

		/* ***************************** */
		/* OUR VALUES BG LOGO ANIMATIONS */
		/* ***************************** */

		const bgLogo = document.querySelector('.bg-logo');

		let tlBgLogo = gsap.timeline({ paused: true });

		tlBgLogo.from(bgLogo, {
			duration: 1,
			xPercent: 15,
			yPercent: -10,
			ease: "Linear.easeNone",
			force3D: true
		});

		ScrollTrigger.create({
			trigger: '.section--our-values',
			start: "top 85%",
			end: "bottom 20%",
			animation: tlBgLogo,
			markers: false,
			toggleActions: "play none none reverse",
			scrub: 0.5 
		});


		/* ****************** */
		/* GALLERY ANIMATIONS */
		/* ****************** */

		const animateImagesContainer = document.querySelector('.animated-images-container');

		const animateImagesRow = animateImagesContainer.querySelectorAll('.animates-images-row');

		const animateImagesRowReverse = animateImagesContainer.querySelectorAll('.animates-images-row-reverse');

		animateImagesRow.forEach(item => {

			let tl = gsap.timeline({  paused: true });

			tl.from(item, {
				duration: 1,
				xPercent: -80,
				ease: Linear.easeNone,
				force3D: true
			});

			ScrollTrigger.create({
				trigger: animateImagesContainer,
				start: "top 85%",
				end: "bottom 10%",
				animation: tl,
				markers: false,
				toggleActions: "play none none reverse",
				scrub: 0.5 
			});

		});

		animateImagesRowReverse.forEach(item => {

			let tl = gsap.timeline({  paused: true });

			tl.to(item, {
				duration: 1,
				xPercent: -80,
				ease: Linear.easeNone,
				force3D: true
			});

			ScrollTrigger.create({
				trigger: animateImagesContainer,
				start: "top 85%",
				end: "bottom 10%",
				animation: tl,
				markers: false,
				toggleActions: "play none none reverse",
				scrub: 0.5 
			});

		});

		
    }
}